import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';

import { sagaApiGen } from 'utils/sagaApiGeneratorHelpers';

import { notificationActions } from '../../../notifications/actions/notification';
import { organizationActions } from '../actions/organization';
import {
  editOrganization,
  getOrganization,
  getPresignedAvatarUrl,
  uploadAvatar,
} from '../api/organization';

const { notificationAdd } = notificationActions;

const {
  organizationV2Get,
  organizationV2GetSucceeded,
  organizationV2GetFailed,

  organizationV2GetPresignedAvatarUrl,
  organizationV2GetPresignedAvatarUrlSucceeded,
  organizationV2GetPresignedAvatarUrlFailed,

  organizationV2UploadAvatarSucceeded,
  organizationV2UploadAvatarFailed,

  organizationV2Edit,
  organizationV2EditSucceeded,
  organizationV2EditFailed,
} = organizationActions;

function* getPresignedGen(action) {
  try {
    const result = yield call(getPresignedAvatarUrl, action.file);

    yield put({
      type: organizationV2GetPresignedAvatarUrlSucceeded.toString(),
      presigned: result.data,
      file: action.file,
      organization: action.organization,
    });
  } catch (e: any) {
    yield put({
      type: organizationV2GetPresignedAvatarUrlFailed.toString(),
      error: e.message,
    });
  }
}

function* uploadAvatarGen(action) {
  try {
    yield call(uploadAvatar, action.presigned, action.file);

    const payload = {
      updates: {
        avatar_url: action.presigned.download_url,
      },
    };

    yield put({
      type: organizationV2UploadAvatarSucceeded.toString(),
      payload: payload,
      id: action.organization.id,
    });
  } catch (e: any) {
    yield put({
      type: organizationV2UploadAvatarFailed.toString(),
      error: e.message,
    });
  }
}

function* editOrganizationGen(action) {
  try {
    const result = yield call(editOrganization, action.id, action.payload);
    const option = {
      title: 'Saved',
      text: `Organization settings saved`,
      className: 'success',
      type: 'organizationSaved',
      icon: 'i-done',
      time: 3000,
    };

    yield put({
      type: organizationV2EditSucceeded.toString(),
      payload: result.data,
    });

    yield put(notificationAdd(option));
  } catch (e: any) {
    yield put({
      type: organizationV2EditFailed.toString(),
      error: e.message,
    });
  }
}

export const organization = [
  takeLatest(
    organizationV2Get.toString(),
    sagaApiGen(
      getOrganization,
      organizationV2GetSucceeded,
      organizationV2GetFailed,
    ),
  ),
  takeEvery(organizationV2GetPresignedAvatarUrl.toString(), getPresignedGen),
  takeEvery(
    organizationV2GetPresignedAvatarUrlSucceeded.toString(),
    uploadAvatarGen,
  ),
  takeLatest(organizationV2Edit.toString(), editOrganizationGen),
  takeLatest(
    organizationV2UploadAvatarSucceeded.toString(),
    editOrganizationGen,
  ),
];
